import { getFunctions, httpsCallable } from "firebase/functions";
import firebaseInit from "../../firebase";

const logActivityFn = httpsCallable(
  getFunctions(firebaseInit.app),
  "logActivity",
);


export const logActivity = async ({
  category,
  event,
  level = `info-${process.env.NODE_ENV}`,
  message,
  metadata = {},
}) => {
  if (process.env.NODE_ENV === "development") {
    return;
  }
  try {
     await logActivityFn({ category, event, level, message, metadata });
  } catch (err) {
    console.error("Logging failed:", err);
  }
};
